<div class="ui attached segment" appMargin marginT="5">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <div fxFlex="12" class="wrapped">
      {{ jsonParser(log.metaData)?.ipAddress || "--" }}
    </div>
    <div fxFlex="30">
      {{ jsonParser(log.metaData)?.hostName || "--" }}
    </div>
    <div fxFlex="12">
      {{ log?.eventDescription || "--" }}
    </div>
    <div fxFlex="12">
      {{ jsonParser(log.metaData)?.username || "--" }}
    </div>
    <div fxFlex="12">
      {{ log?.dateCreated | amTimeAgo }}
    </div>
    <div fxFlex="12">
      <div
        class="ui small circular medium label"
        [ngClass]="{
          green: log?.status === 'ACTIVE' || log?.status === 'SUCCESS',
          red: log?.status === 'REJECTED' || log?.status === 'FAILURE',
          teal: log?.status === 'ON_GOING'
        }"
      >
        {{ log?.status | removeUnderscore }}
      </div>
    </div>
    <div fxFlex="10">
      <div class="ui column right aligned right-side-buttons">
        <div class="ui basic dropdown custom-dropdown" suiDropdown>
          <div class="text">Actions</div>
          <div class="vertical-divider"></div>
          <div class="dropdown-icon">
            <i class="dropdown icon"></i>
          </div>
          <div
            class="left menu primary"
            appMargin
            marginT="12px"
            suiDropdownMenu
          >
            <div
              class="item"
              style="
                font-weight: 400 !important;
                font-size: 13px !important;
                color: #505050 !important;
              "
              *ngIf="log?.eventType === 'IP_ADDRESS'"
              (click)="blacklistIPAddress.emit(log)"
            >
              Whitelist IP Address
            </div>
            <div
              class="item"
              style="
                font-weight: 400 !important;
                font-size: 13px !important;
                color: #505050 !important;
              "
              (click)="createAlert.emit(log)"
              *ngIf="checkPermission('APPLICATION_SECURITY_MODULE', 'add')"
            >
              Create Alert
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
